import { render, staticRenderFns } from "./LocationPrimaryGeofence.vue?vue&type=template&id=51c2612c&scoped=true"
import script from "./LocationPrimaryGeofence.vue?vue&type=script&lang=js"
export * from "./LocationPrimaryGeofence.vue?vue&type=script&lang=js"
import style0 from "./LocationPrimaryGeofence.vue?vue&type=style&index=0&id=51c2612c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2612c",
  null
  
)

export default component.exports